module.exports = __webpack_public_path__ + "img/tools-question.649d69cf.png";